export const DEPUTATI = [
	{
		"id" : "PD0025270",
		"cognome" : "ABOZZI",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0011840",
		"cognome" : "ADONNINO",
		"nome" : "Giovan Battista"
	},
	{
		"id" : "PD0006320",
		"cognome" : "ALBERGANTI",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0025700",
		"cognome" : "ALBERTI",
		"nome" : "Antonio"
	},
	{
		"id" : "PD0025290",
		"cognome" : "ALDISIO",
		"nome" : "Salvatore"
	},
	{
		"id" : "PD0013360",
		"cognome" : "ALLEGATO",
		"nome" : "Luigi"
	},
	{
		"id" : "PD0006370",
		"cognome" : "AMADEI",
		"nome" : "Leonetto"
	},
	{
		"id" : "PD0006420",
		"cognome" : "AMBROSINI",
		"nome" : "Gaspare"
	},
	{
		"id" : "PD0000200",
		"cognome" : "AMENDOLA",
		"nome" : "Giorgio"
	},
	{
		"id" : "PD0200021",
		"cognome" : "ANDREOTTI",
		"nome" : "Giulio"
	},
	{
		"id" : "PD0017750",
		"cognome" : "ANGELINI",
		"nome" : "Armando"
	},
	{
		"id" : "PD0006460",
		"cognome" : "ANGELUCCI",
		"nome" : "Nicola"
	},
	{
		"id" : "PD0006480",
		"cognome" : "ARATA",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0006490",
		"cognome" : "ARCAINI",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0025310",
		"cognome" : "ARCANGELI",
		"nome" : "Alessandro"
	},
	{
		"id" : "PD0006510",
		"cognome" : "ASSENNATO",
		"nome" : "Mario"
	},
	{
		"id" : "PD0011650",
		"cognome" : "AVANZINI",
		"nome" : "Ennio"
	},
	{
		"id" : "PD0027160",
		"cognome" : "AYROLDI",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0012560",
		"cognome" : "AZZI",
		"nome" : "Arnaldo"
	},
	{
		"id" : "PD0006520",
		"cognome" : "BACCICONI",
		"nome" : "Luigi"
	},
	{
		"id" : "PD0000400",
		"cognome" : "BADINI CONFALONIERI",
		"nome" : "Vittorio"
	},
	{
		"id" : "PD0006540",
		"cognome" : "BALDASSARI",
		"nome" : "Gino"
	},
	{
		"id" : "PD0006560",
		"cognome" : "BALDUZZI",
		"nome" : "Luigi"
	},
	{
		"id" : "PD0027200",
		"cognome" : "BARBARESCHI",
		"nome" : "Gaetano"
	},
	{
		"id" : "PD0027210",
		"cognome" : "BARGAGNA",
		"nome" : "Italo"
	},
	{
		"id" : "PD0017840",
		"cognome" : "BARONTINI",
		"nome" : "Anelito"
	},
	{
		"id" : "PD0027220",
		"cognome" : "BARONTINI",
		"nome" : "Ilio"
	},
	{
		"id" : "PD0027230",
		"cognome" : "BARTALINI",
		"nome" : "Ezio"
	},
	{
		"id" : "PD0006680",
		"cognome" : "BASILE",
		"nome" : "Guido"
	},
	{
		"id" : "PD0027240",
		"cognome" : "BASSANO",
		"nome" : "Carlo"
	},
	{
		"id" : "PD0017850",
		"cognome" : "BASSO",
		"nome" : "Lelio"
	},
	{
		"id" : "PD0012230",
		"cognome" : "BASTIANETTO",
		"nome" : "Celeste"
	},
	{
		"id" : "PD0011370",
		"cognome" : "BATTISTI",
		"nome" : "Luigi"
	},
	{
		"id" : "PD0006720",
		"cognome" : "BAZOLI",
		"nome" : "Stefano"
	},
	{
		"id" : "PD0006740",
		"cognome" : "BEI CIUFOLI",
		"nome" : "Adele"
	},
	{
		"id" : "PD0006750",
		"cognome" : "BELLATO",
		"nome" : "Angelo"
	},
	{
		"id" : "PD0006760",
		"cognome" : "BELLAVISTA",
		"nome" : "Girolamo"
	},
	{
		"id" : "PD0027250",
		"cognome" : "BELLUSCI",
		"nome" : "Giuseppe Salvatore"
	},
	{
		"id" : "PD0017860",
		"cognome" : "BELOTTI",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0027260",
		"cognome" : "BENCIVENGA",
		"nome" : "Roberto"
	},
	{
		"id" : "PD0027270",
		"cognome" : "BENEDETTI",
		"nome" : "Tullio"
	},
	{
		"id" : "PD0006780",
		"cognome" : "BENEDETTINI",
		"nome" : "Luigi Filippo"
	},
	{
		"id" : "PD0006790",
		"cognome" : "BENNANI",
		"nome" : "Luigi"
	},
	{
		"id" : "PD0011330",
		"cognome" : "BENVENUTI",
		"nome" : "Lodovico"
	},
	{
		"id" : "PD0027280",
		"cognome" : "BERGAMINI",
		"nome" : "Alberto"
	},
	{
		"id" : "PD0011490",
		"cognome" : "BERNAMONTI",
		"nome" : "Dante"
	},
	{
		"id" : "PD0011790",
		"cognome" : "BERNARDI",
		"nome" : "Adriano"
	},
	{
		"id" : "PD0027300",
		"cognome" : "BERNINI",
		"nome" : "Ferdinando"
	},
	{
		"id" : "PD0027310",
		"cognome" : "BERTINI",
		"nome" : "Giovanni"
	},
	{
		"id" : "PD0017930",
		"cognome" : "BERTOLA",
		"nome" : "Ermenegildo"
	},
	{
		"id" : "PD0027320",
		"cognome" : "BERTONE",
		"nome" : "Giovanni Battista"
	},
	{
		"id" : "PD0017950",
		"cognome" : "BETTIOL",
		"nome" : "Giuseppe Maria"
	},
	{
		"id" : "PD0000800",
		"cognome" : "BIAGIONI",
		"nome" : "Loris"
	},
	{
		"id" : "PD0012870",
		"cognome" : "BIANCHI",
		"nome" : "Costantino"
	},
	{
		"id" : "PD0006880",
		"cognome" : "BIANCHI",
		"nome" : "Bianca"
	},
	{
		"id" : "PD0006890",
		"cognome" : "BIANCHI",
		"nome" : "Bruno"
	},
	{
		"id" : "PD0006920",
		"cognome" : "BIANCHINI",
		"nome" : "Laura"
	},
	{
		"id" : "PD0027330",
		"cognome" : "BIBOLOTTI",
		"nome" : "Aladino"
	},
	{
		"id" : "PD0006970",
		"cognome" : "BINNI",
		"nome" : "Walter"
	},
	{
		"id" : "PD0027340",
		"cognome" : "BITOSSI",
		"nome" : "Renato"
	},
	{
		"id" : "PD0027350",
		"cognome" : "BOCCONI",
		"nome" : "Alessandro"
	},
	{
		"id" : "PD0000950",
		"cognome" : "BOLDRINI",
		"nome" : "Arrigo"
	},
	{
		"id" : "PD0027360",
		"cognome" : "BOLOGNESI",
		"nome" : "Severino"
	},
	{
		"id" : "PD0007020",
		"cognome" : "BONFANTINI",
		"nome" : "Corrado"
	},
	{
		"id" : "PD0018020",
		"cognome" : "BONINO",
		"nome" : "Uberto"
	},
	{
		"id" : "PD0012620",
		"cognome" : "BONOMELLI",
		"nome" : "Oreste"
	},
	{
		"id" : "PD0001000",
		"cognome" : "BONOMI",
		"nome" : "Paolo"
	},
	{
		"id" : "PD0027370",
		"cognome" : "BONOMI",
		"nome" : "Ivanoe"
	},
	{
		"id" : "PD0027380",
		"cognome" : "BORDON",
		"nome" : "Giulio"
	},
	{
		"id" : "PD0007070",
		"cognome" : "BORSELLINO",
		"nome" : "Raimondo"
	},
	{
		"id" : "PD0025410",
		"cognome" : "BOSCO LUCARELLI",
		"nome" : "Giambattista"
	},
	{
		"id" : "PD0027390",
		"cognome" : "BOSI",
		"nome" : "Ilio"
	},
	{
		"id" : "PD0012350",
		"cognome" : "BOVETTI",
		"nome" : "Giovanni"
	},
	{
		"id" : "PD0001110",
		"cognome" : "BOZZI",
		"nome" : "Aldo"
	},
	{
		"id" : "PD0027400",
		"cognome" : "BRASCHI",
		"nome" : "Giovanni"
	},
	{
		"id" : "PD0014250",
		"cognome" : "BRUNI",
		"nome" : "Gerardo"
	},
	{
		"id" : "PD0013530",
		"cognome" : "BUBBIO",
		"nome" : "Teodoro"
	},
	{
		"id" : "PD0027410",
		"cognome" : "BUFFONI",
		"nome" : "Francesco"
	},
	{
		"id" : "PD0025430",
		"cognome" : "BULLONI",
		"nome" : "Pietro"
	},
	{
		"id" : "PD0027420",
		"cognome" : "BUONOCORE",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0011800",
		"cognome" : "BURATO",
		"nome" : "Arturo"
	},
	{
		"id" : "PD0025440",
		"cognome" : "CACCURI",
		"nome" : "Edmondo"
	},
	{
		"id" : "PD0011900",
		"cognome" : "CAIRO",
		"nome" : "Arrigo"
	},
	{
		"id" : "PD0025450",
		"cognome" : "CALAMANDREI",
		"nome" : "Piero"
	},
	{
		"id" : "PD0027430",
		"cognome" : "CALDERA",
		"nome" : "Carlo"
	},
	{
		"id" : "PD0012700",
		"cognome" : "CALOSSO",
		"nome" : "Umberto"
	},
	{
		"id" : "PD0017230",
		"cognome" : "CAMANGI",
		"nome" : "Ludovico"
	},
	{
		"id" : "PD0007210",
		"cognome" : "CAMPOSARCUNO",
		"nome" : "Michele"
	},
	{
		"id" : "PD0027440",
		"cognome" : "CANDELA",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0027460",
		"cognome" : "CANEPA",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0027450",
		"cognome" : "CANEVARI",
		"nome" : "Emilio"
	},
	{
		"id" : "PD0012000",
		"cognome" : "CANNIZZO",
		"nome" : "Bartolomeo"
	},
	{
		"id" : "PD0027470",
		"cognome" : "CAPORALI",
		"nome" : "Giovanni Ernesto"
	},
	{
		"id" : "PD0011350",
		"cognome" : "CAPPA",
		"nome" : "Paolo"
	},
	{
		"id" : "PD0007240",
		"cognome" : "CAPPELLETTI",
		"nome" : "Guglielmo"
	},
	{
		"id" : "PD0025470",
		"cognome" : "CAPPI",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0007250",
		"cognome" : "CAPPUGI",
		"nome" : "Renato"
	},
	{
		"id" : "PD0027480",
		"cognome" : "CAPRANI",
		"nome" : "Aldo"
	},
	{
		"id" : "PD0018170",
		"cognome" : "CAPUA",
		"nome" : "Antonio"
	},
	{
		"id" : "PD0027500",
		"cognome" : "CARBONARI",
		"nome" : "Luigi"
	},
	{
		"id" : "PD0007280",
		"cognome" : "CARBONI",
		"nome" : "Angelo"
	},
	{
		"id" : "PD0027520",
		"cognome" : "CARBONI",
		"nome" : "Enrico"
	},
	{
		"id" : "PD0012450",
		"cognome" : "CARIGNANI",
		"nome" : "Giovanni"
	},
	{
		"id" : "PD0027530",
		"cognome" : "CARISTIA",
		"nome" : "Carmelo"
	},
	{
		"id" : "PD0027540",
		"cognome" : "CARMAGNOLA",
		"nome" : "Luigi"
	},
	{
		"id" : "PD0013010",
		"cognome" : "CAROLEO",
		"nome" : "Francesco"
	},
	{
		"id" : "PD0007300",
		"cognome" : "CARONIA",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0011320",
		"cognome" : "CARPANO MAGLIOLI",
		"nome" : "Ernesto"
	},
	{
		"id" : "PD0025490",
		"cognome" : "CARRATELLI",
		"nome" : "Benedetto"
	},
	{
		"id" : "PD0013510",
		"cognome" : "CARTIA",
		"nome" : "Giovanni"
	},
	{
		"id" : "PD0012850",
		"cognome" : "CASO",
		"nome" : "Giovanni"
	},
	{
		"id" : "PD0018290",
		"cognome" : "CASSIANI",
		"nome" : "Gennaro"
	},
	{
		"id" : "PD0007350",
		"cognome" : "CASTELLI",
		"nome" : "Edgardo"
	},
	{
		"id" : "PD0025500",
		"cognome" : "CASTELLI AVOLIO",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0007360",
		"cognome" : "CASTIGLIA",
		"nome" : "Pietro"
	},
	{
		"id" : "PD0007390",
		"cognome" : "CAVALLARI",
		"nome" : "Vincenzo"
	},
	{
		"id" : "PD0007420",
		"cognome" : "CAVALLOTTI",
		"nome" : "Alberto Mario"
	},
	{
		"id" : "PD0018180",
		"cognome" : "CERRETI",
		"nome" : "Giulio"
	},
	{
		"id" : "PD0013590",
		"cognome" : "CEVOLOTTO",
		"nome" : "Mario"
	},
	{
		"id" : "PD0013110",
		"cognome" : "CHATRIAN",
		"nome" : "Luigi"
	},
	{
		"id" : "PD0007460",
		"cognome" : "CHIARAMELLO",
		"nome" : "Domenico"
	},
	{
		"id" : "PD0012300",
		"cognome" : "CHIEFFI",
		"nome" : "Francesco"
	},
	{
		"id" : "PD0025580",
		"cognome" : "CHIOSTERGI",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0027580",
		"cognome" : "CIAMPITTI",
		"nome" : "Giovanni"
	},
	{
		"id" : "PD0027590",
		"cognome" : "CIANCA",
		"nome" : "Alberto"
	},
	{
		"id" : "PD0027600",
		"cognome" : "CICCOLUNGO",
		"nome" : "Nicola"
	},
	{
		"id" : "PD0007520",
		"cognome" : "CICERONE",
		"nome" : "Vincenzo"
	},
	{
		"id" : "PD0025590",
		"cognome" : "CIFALDI",
		"nome" : "Antonio"
	},
	{
		"id" : "PD0012990",
		"cognome" : "CIMENTI",
		"nome" : "Fiorenzo"
	},
	{
		"id" : "PD0027610",
		"cognome" : "CINGOLANI",
		"nome" : "Mario"
	},
	{
		"id" : "PD0014040",
		"cognome" : "CLERICI",
		"nome" : "Edoardo"
	},
	{
		"id" : "PD0007540",
		"cognome" : "COCCIA",
		"nome" : "Ivo"
	},
	{
		"id" : "PD0001750",
		"cognome" : "CODACCI PISANELLI",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0018330",
		"cognome" : "CODIGNOLA",
		"nome" : "Tristano"
	},
	{
		"id" : "PD0007550",
		"cognome" : "COLITTO",
		"nome" : "Francesco"
	},
	{
		"id" : "PD0018370",
		"cognome" : "COLOMBI",
		"nome" : "Arturo"
	},
	{
		"id" : "PD0001770",
		"cognome" : "COLOMBO",
		"nome" : "Emilio"
	},
	{
		"id" : "PD0011360",
		"cognome" : "COLONNETTI",
		"nome" : "Gustavo"
	},
	{
		"id" : "PD0025630",
		"cognome" : "CONCI",
		"nome" : "Elisabetta"
	},
	{
		"id" : "PD0025630",
		"cognome" : "CONCI",
		"nome" : "Elisabetta (Elsa)"
	},
	{
		"id" : "PD0027630",
		"cognome" : "CONDORELLI",
		"nome" : "Orazio"
	},
	{
		"id" : "PD0027640",
		"cognome" : "CONTI",
		"nome" : "Giovanni"
	},
	{
		"id" : "PD0012760",
		"cognome" : "COPPA",
		"nome" : "Ezio"
	},
	{
		"id" : "PD0012220",
		"cognome" : "COPPI",
		"nome" : "Alessandro"
	},
	{
		"id" : "PD0027660",
		"cognome" : "CORAZZIN",
		"nome" : "Luigi"
	},
	{
		"id" : "PD0007570",
		"cognome" : "CORBI",
		"nome" : "Bruno"
	},
	{
		"id" : "PD0007580",
		"cognome" : "CORBINO",
		"nome" : "Epicarmo"
	},
	{
		"id" : "PD0012020",
		"cognome" : "CORSANEGO",
		"nome" : "Camillo"
	},
	{
		"id" : "PD0013130",
		"cognome" : "CORSI",
		"nome" : "Angelo"
	},
	{
		"id" : "PD0300643",
		"cognome" : "CORSINI",
		"nome" : "Tommaso"
	},
	{
		"id" : "PD0013390",
		"cognome" : "CORTESE",
		"nome" : "Pasquale"
	},
	{
		"id" : "PD0011340",
		"cognome" : "CORTESE",
		"nome" : "Guido"
	},
	{
		"id" : "PD0027680",
		"cognome" : "COSATTINI",
		"nome" : "Giovanni"
	},
	{
		"id" : "PD0025650",
		"cognome" : "COSTA",
		"nome" : "Gastone"
	},
	{
		"id" : "PD0027690",
		"cognome" : "COSTANTINI",
		"nome" : "Antonio"
	},
	{
		"id" : "PD0007610",
		"cognome" : "COTELLESSA",
		"nome" : "Mario"
	},
	{
		"id" : "PD0001930",
		"cognome" : "COVELLI",
		"nome" : "Alfredo"
	},
	{
		"id" : "PD0012260",
		"cognome" : "CREMASCHI",
		"nome" : "Olindo"
	},
	{
		"id" : "PD0007620",
		"cognome" : "CREMASCHI",
		"nome" : "Carlo"
	},
	{
		"id" : "PD0027700",
		"cognome" : "CRISPO",
		"nome" : "Amerigo"
	},
	{
		"id" : "PD0027710",
		"cognome" : "CROCE",
		"nome" : "Benedetto"
	},
	{
		"id" : "PD0012240",
		"cognome" : "CUOMO",
		"nome" : "Giovanni"
	},
	{
		"id" : "PD0027720",
		"cognome" : "D'AGATA",
		"nome" : "Antonino"
	},
	{
		"id" : "PD0007700",
		"cognome" : "DAMIANI",
		"nome" : "Ugo"
	},
	{
		"id" : "PD0027730",
		"cognome" : "D'AMICO",
		"nome" : "Diego"
	},
	{
		"id" : "PD0007710",
		"cognome" : "D'AMICO",
		"nome" : "Michele"
	},
	{
		"id" : "PD0027740",
		"cognome" : "D'ARAGONA",
		"nome" : "Lodovico"
	},
	{
		"id" : "PD0025690",
		"cognome" : "DE CARO",
		"nome" : "Raffaele"
	},
	{
		"id" : "PD0007750",
		"cognome" : "DE CARO",
		"nome" : "Gerardo"
	},
	{
		"id" : "PD0012710",
		"cognome" : "DE FALCO",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0012180",
		"cognome" : "DE FILPO",
		"nome" : "Luigi"
	},
	{
		"id" : "PD0013230",
		"cognome" : "DE GASPERI",
		"nome" : "Alcide"
	},
	{
		"id" : "PD0002180",
		"cognome" : "DE MARIA",
		"nome" : "Beniamino"
	},
	{
		"id" : "PD0011450",
		"cognome" : "DE MARTINO",
		"nome" : "Carmine"
	},
	{
		"id" : "PD0007850",
		"cognome" : "DE MERCURIO",
		"nome" : "Ugo"
	},
	{
		"id" : "PD0018560",
		"cognome" : "DE MICHELE",
		"nome" : "Luigi"
	},
	{
		"id" : "PD0027770",
		"cognome" : "DE MICHELIS",
		"nome" : "Paolo"
	},
	{
		"id" : "PD0017200",
		"cognome" : "DE PALMA",
		"nome" : "Giacomo"
	},
	{
		"id" : "PD0014290",
		"cognome" : "DE UNTERRICHTER JERVOLINO",
		"nome" : "Maria"
	},
	{
		"id" : "PD0011300",
		"cognome" : "DE VITA",
		"nome" : "Francesco"
	},
	{
		"id" : "PD0027750",
		"cognome" : "DEL CURTO",
		"nome" : "Giovanni"
	},
	{
		"id" : "PD0025710",
		"cognome" : "DELLA SETA",
		"nome" : "Ugo"
	},
	{
		"id" : "PD0007830",
		"cognome" : "DELLI CASTELLI",
		"nome" : "Filomena"
	},
	{
		"id" : "PD0025740",
		"cognome" : "DI FAUSTO",
		"nome" : "Florestano"
	},
	{
		"id" : "PD0027780",
		"cognome" : "DI GIOVANNI",
		"nome" : "Eduardo"
	},
	{
		"id" : "PD0017310",
		"cognome" : "DI GLORIA",
		"nome" : "Calogero"
	},
	{
		"id" : "PD0025750",
		"cognome" : "DI VITTORIO",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0025760",
		"cognome" : "DOMINEDO'",
		"nome" : "Francesco Maria"
	},
	{
		"id" : "PD0025760",
		"cognome" : "DOMINEDO'",
		"nome" : "Francesco"
	},
	{
		"id" : "PD0007990",
		"cognome" : "DONATI",
		"nome" : "Antigono"
	},
	{
		"id" : "PD0011390",
		"cognome" : "D'ONOFRIO",
		"nome" : "Edoardo"
	},
	{
		"id" : "PD0025780",
		"cognome" : "DOSSETTI",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0013900",
		"cognome" : "DOZZA",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0011520",
		"cognome" : "DUGONI",
		"nome" : "Eugenio"
	},
	{
		"id" : "PD0027790",
		"cognome" : "EINAUDI",
		"nome" : "Luigi"
	},
	{
		"id" : "PD0018700",
		"cognome" : "ERMINI",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0027800",
		"cognome" : "FABBRI",
		"nome" : "Gustavo"
	},
	{
		"id" : "PD0008020",
		"cognome" : "FABRIANI",
		"nome" : "Arnaldo"
	},
	{
		"id" : "PD0025820",
		"cognome" : "FACCIO",
		"nome" : "Luigi"
	},
	{
		"id" : "PD0008060",
		"cognome" : "FALCHI",
		"nome" : "Battista"
	},
	{
		"id" : "PD0200365",
		"cognome" : "FANFANI",
		"nome" : "Amintore"
	},
	{
		"id" : "PD0027820",
		"cognome" : "FANTONI",
		"nome" : "Luciano"
	},
	{
		"id" : "PD0025830",
		"cognome" : "FARALLI",
		"nome" : "Vannuccio"
	},
	{
		"id" : "PD0011430",
		"cognome" : "FARINI",
		"nome" : "Carlo"
	},
	{
		"id" : "PD0025850",
		"cognome" : "FEDELI",
		"nome" : "Aldo"
	},
	{
		"id" : "PD0008120",
		"cognome" : "FEDERICI AGAMBEN",
		"nome" : "Maria"
	},
	{
		"id" : "PD0013790",
		"cognome" : "FERRARESE",
		"nome" : "Antonio"
	},
	{
		"id" : "PD0027860",
		"cognome" : "FERRARI",
		"nome" : "Giacomo"
	},
	{
		"id" : "PD0025870",
		"cognome" : "FERRARIO",
		"nome" : "Celestino"
	},
	{
		"id" : "PD0025890",
		"cognome" : "FERRERI",
		"nome" : "Pietro"
	},
	{
		"id" : "PD0011590",
		"cognome" : "FIETTA",
		"nome" : "Cornelio"
	},
	{
		"id" : "PD0027870",
		"cognome" : "FILIPPINI",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0025900",
		"cognome" : "FINOCCHIARO APRILE",
		"nome" : "Andrea"
	},
	{
		"id" : "PD0027880",
		"cognome" : "FIORE",
		"nome" : "Umberto"
	},
	{
		"id" : "PD0008180",
		"cognome" : "FIORENTINO",
		"nome" : "Giosue'"
	},
	{
		"id" : "PD0027890",
		"cognome" : "FIORITTO",
		"nome" : "Domenico"
	},
	{
		"id" : "PD0025920",
		"cognome" : "FIRRAO",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0008210",
		"cognome" : "FOA",
		"nome" : "Vittorio"
	},
	{
		"id" : "PD0025940",
		"cognome" : "FOGAGNOLO",
		"nome" : "Alberto"
	},
	{
		"id" : "PD0008250",
		"cognome" : "FORESI",
		"nome" : "Palmiro"
	},
	{
		"id" : "PD0025950",
		"cognome" : "FORNARA",
		"nome" : "Piero"
	},
	{
		"id" : "PD0008300",
		"cognome" : "FRANCESCHINI",
		"nome" : "Francesco"
	},
	{
		"id" : "PD0025970",
		"cognome" : "FRESA",
		"nome" : "Armando"
	},
	{
		"id" : "PD0018780",
		"cognome" : "FROGGIO",
		"nome" : "Giacinto"
	},
	{
		"id" : "PD0025990",
		"cognome" : "FUSCHINI",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0027910",
		"cognome" : "FUSCO",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0008360",
		"cognome" : "GABRIELI",
		"nome" : "Antonio"
	},
	{
		"id" : "PD0012440",
		"cognome" : "GALATI",
		"nome" : "Vito Giusepe"
	},
	{
		"id" : "PD0012440",
		"cognome" : "GALATI",
		"nome" : "Vito Giuseppe"
	},
	{
		"id" : "PD0008370",
		"cognome" : "GALIOTO",
		"nome" : "Michelangelo"
	},
	{
		"id" : "PD0008380",
		"cognome" : "GALLICO SPANO",
		"nome" : "Nadia"
	},
	{
		"id" : "PD0008390",
		"cognome" : "GALLO",
		"nome" : "Concetto"
	},
	{
		"id" : "PD0018810",
		"cognome" : "GARLATO",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0027920",
		"cognome" : "GASPAROTTO",
		"nome" : "Luigi"
	},
	{
		"id" : "PD0014190",
		"cognome" : "GATTA",
		"nome" : "Alessandro"
	},
	{
		"id" : "PD0027930",
		"cognome" : "GAVINA",
		"nome" : "Cesare"
	},
	{
		"id" : "PD0008460",
		"cognome" : "GERMANO",
		"nome" : "Attilio"
	},
	{
		"id" : "PD0027940",
		"cognome" : "GERVASI",
		"nome" : "Galliano"
	},
	{
		"id" : "PD0008480",
		"cognome" : "GEUNA",
		"nome" : "Silvio"
	},
	{
		"id" : "PD0013300",
		"cognome" : "GHIDETTI",
		"nome" : "Vittorio"
	},
	{
		"id" : "PD0027950",
		"cognome" : "GHIDINI",
		"nome" : "Gustavo"
	},
	{
		"id" : "PD0026040",
		"cognome" : "GHISLANDI",
		"nome" : "Guglielmo"
	},
	{
		"id" : "PD0008500",
		"cognome" : "GIACCHERO",
		"nome" : "Enzo"
	},
	{
		"id" : "PD0026060",
		"cognome" : "GIANNINI",
		"nome" : "Guglielmo"
	},
	{
		"id" : "PD0002930",
		"cognome" : "GIOLITTI",
		"nome" : "Antonio"
	},
	{
		"id" : "PD0008540",
		"cognome" : "GIORDANI",
		"nome" : "Igino"
	},
	{
		"id" : "PD0027970",
		"cognome" : "GIUA",
		"nome" : "Michele"
	},
	{
		"id" : "PD0027980",
		"cognome" : "GORTANI",
		"nome" : "Michele"
	},
	{
		"id" : "PD0008610",
		"cognome" : "GOTELLI",
		"nome" : "Angela"
	},
	{
		"id" : "PD0027990",
		"cognome" : "GRANDI",
		"nome" : "Achille"
	},
	{
		"id" : "PD0011780",
		"cognome" : "GRASSI",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0012570",
		"cognome" : "GRAZI",
		"nome" : "Enrico"
	},
	{
		"id" : "PD0011810",
		"cognome" : "GRAZIA",
		"nome" : "Verenin"
	},
	{
		"id" : "PD0008670",
		"cognome" : "GREPPI",
		"nome" : "Antonio"
	},
	{
		"id" : "PD0028000",
		"cognome" : "GRIECO",
		"nome" : "Ruggero"
	},
	{
		"id" : "PD0026130",
		"cognome" : "GRILLI",
		"nome" : "Umberto"
	},
	{
		"id" : "PD0018950",
		"cognome" : "GRONCHI",
		"nome" : "Giovanni"
	},
	{
		"id" : "PD0014060",
		"cognome" : "GUARIENTO",
		"nome" : "Antonio"
	},
	{
		"id" : "PD0011530",
		"cognome" : "GUERRIERI",
		"nome" : "Filippo"
	},
	{
		"id" : "PD0013640",
		"cognome" : "GUERRIERI",
		"nome" : "Emanuele"
	},
	{
		"id" : "PD0003080",
		"cognome" : "GUI",
		"nome" : "Luigi"
	},
	{
		"id" : "PD0008730",
		"cognome" : "GUIDI CINGOLANI",
		"nome" : "Angela Maria"
	},
	{
		"id" : "PD0011700",
		"cognome" : "GULLO",
		"nome" : "Rocco"
	},
	{
		"id" : "PD0011230",
		"cognome" : "GULLO",
		"nome" : "Fausto"
	},
	{
		"id" : "PD0026150",
		"cognome" : "IMPERIALE",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0003140",
		"cognome" : "IOTTI",
		"nome" : "Nilde"
	},
	{
		"id" : "PD0028020",
		"cognome" : "JACINI",
		"nome" : "Stefano"
	},
	{
		"id" : "PD0008770",
		"cognome" : "JACOMETTI",
		"nome" : "Alberto"
	},
	{
		"id" : "PD0012690",
		"cognome" : "LA GRAVINESE",
		"nome" : "Nicola"
	},
	{
		"id" : "PD0003250",
		"cognome" : "LA MALFA",
		"nome" : "Ugo"
	},
	{
		"id" : "PD0008810",
		"cognome" : "LA PIRA",
		"nome" : "Giorgio"
	},
	{
		"id" : "PD0011710",
		"cognome" : "LA ROCCA",
		"nome" : "Vincenzo"
	},
	{
		"id" : "PD0028030",
		"cognome" : "LABRIOLA",
		"nome" : "Arturo"
	},
	{
		"id" : "PD0011820",
		"cognome" : "LACONI",
		"nome" : "Renzo"
	},
	{
		"id" : "PD0026170",
		"cognome" : "LAGRAVINESE",
		"nome" : "Pasquale"
	},
	{
		"id" : "PD0018990",
		"cognome" : "LAMI STARNUTI",
		"nome" : "Edgardo"
	},
	{
		"id" : "PD0008800",
		"cognome" : "LANDI",
		"nome" : "Romolo"
	},
	{
		"id" : "PD0200511",
		"cognome" : "LEONE",
		"nome" : "Giovanni"
	},
	{
		"id" : "PD0008860",
		"cognome" : "LEONE",
		"nome" : "Francesco"
	},
	{
		"id" : "PD0026190",
		"cognome" : "LETTIERI",
		"nome" : "Raffaele"
	},
	{
		"id" : "PD0026200",
		"cognome" : "LI CAUSI",
		"nome" : "Girolamo"
	},
	{
		"id" : "PD0017250",
		"cognome" : "LIZZADRI",
		"nome" : "Oreste"
	},
	{
		"id" : "PD0003460",
		"cognome" : "LOMBARDI",
		"nome" : "Riccardo"
	},
	{
		"id" : "PD0019090",
		"cognome" : "LOMBARDI",
		"nome" : "Carlo"
	},
	{
		"id" : "PD0028040",
		"cognome" : "LOMBARDI",
		"nome" : "Giovanni"
	},
	{
		"id" : "PD0008930",
		"cognome" : "LOMBARDO",
		"nome" : "Ivan Matteo"
	},
	{
		"id" : "PD0026240",
		"cognome" : "LONGHENA",
		"nome" : "Mario"
	},
	{
		"id" : "PD0003470",
		"cognome" : "LONGO",
		"nome" : "Luigi"
	},
	{
		"id" : "PD0028050",
		"cognome" : "LOPARDI",
		"nome" : "Emidio"
	},
	{
		"id" : "PD0014030",
		"cognome" : "LOZZA",
		"nome" : "Stellio"
	},
	{
		"id" : "PD0008950",
		"cognome" : "LUCIFERO D'APRIGLIANO",
		"nome" : "Roberto"
	},
	{
		"id" : "PD0028060",
		"cognome" : "LUISETTI",
		"nome" : "Virgilio"
	},
	{
		"id" : "PD0028070",
		"cognome" : "LUSSU",
		"nome" : "Emilio"
	},
	{
		"id" : "PD0026250",
		"cognome" : "MACRELLI",
		"nome" : "Cino"
	},
	{
		"id" : "PD0028080",
		"cognome" : "MAFFI",
		"nome" : "Fabrizio"
	},
	{
		"id" : "PD0008980",
		"cognome" : "MAFFIOLI",
		"nome" : "Catullo"
	},
	{
		"id" : "PD0026260",
		"cognome" : "MAGNANI",
		"nome" : "Marino"
	},
	{
		"id" : "PD0028090",
		"cognome" : "MAGRASSI",
		"nome" : "Eliseo Giovanni"
	},
	{
		"id" : "PD0011610",
		"cognome" : "MAGRINI",
		"nome" : "Luciano"
	},
	{
		"id" : "PD0012190",
		"cognome" : "MALAGUGINI",
		"nome" : "Alcide"
	},
	{
		"id" : "PD0027760",
		"cognome" : "MALTAGLIATI",
		"nome" : "Abdon"
	},
	{
		"id" : "PD0012490",
		"cognome" : "MALVESTITI",
		"nome" : "Piero"
	},
	{
		"id" : "PD0028100",
		"cognome" : "MANCINI",
		"nome" : "Pietro"
	},
	{
		"id" : "PD0026280",
		"cognome" : "MANNIRONI",
		"nome" : "Salvatore"
	},
	{
		"id" : "PD0009030",
		"cognome" : "MANZINI",
		"nome" : "Raimondo"
	},
	{
		"id" : "PD0026320",
		"cognome" : "MARCHESI",
		"nome" : "Concetto"
	},
	{
		"id" : "PD0026330",
		"cognome" : "MARCONI",
		"nome" : "Pasquale"
	},
	{
		"id" : "PD0028110",
		"cognome" : "MARIANI",
		"nome" : "Francesco"
	},
	{
		"id" : "PD0009060",
		"cognome" : "MARIANI",
		"nome" : "Enrico"
	},
	{
		"id" : "PD0028120",
		"cognome" : "MARINA",
		"nome" : "Mario"
	},
	{
		"id" : "PD0026340",
		"cognome" : "MARINARO",
		"nome" : "Francesco"
	},
	{
		"id" : "PD0028130",
		"cognome" : "MARINELLI",
		"nome" : "Oddo"
	},
	{
		"id" : "PD0009090",
		"cognome" : "MARTINO",
		"nome" : "Enrico"
	},
	{
		"id" : "PD0013430",
		"cognome" : "MARTINO",
		"nome" : "Gaetano"
	},
	{
		"id" : "PD0026360",
		"cognome" : "MARZAROTTO",
		"nome" : "Achille"
	},
	{
		"id" : "PD0028140",
		"cognome" : "MASSINI",
		"nome" : "Cesare"
	},
	{
		"id" : "PD0028150",
		"cognome" : "MASTINO",
		"nome" : "Pietro"
	},
	{
		"id" : "PD0026390",
		"cognome" : "MASTINO",
		"nome" : "Gesumino"
	},
	{
		"id" : "PD0026400",
		"cognome" : "MASTROJANNI",
		"nome" : "Ottavio"
	},
	{
		"id" : "PD0011660",
		"cognome" : "MATTARELLA",
		"nome" : "Bernardo"
	},
	{
		"id" : "PD0019260",
		"cognome" : "MATTEI",
		"nome" : "Teresa"
	},
	{
		"id" : "PD0003920",
		"cognome" : "MATTEOTTI",
		"nome" : "Matteo"
	},
	{
		"id" : "PD0009170",
		"cognome" : "MATTEOTTI",
		"nome" : "Carlo"
	},
	{
		"id" : "PD0009190",
		"cognome" : "MAZZA",
		"nome" : "Crescenzo"
	},
	{
		"id" : "PD0009200",
		"cognome" : "MAZZEI",
		"nome" : "Vincenzo"
	},
	{
		"id" : "PD0028160",
		"cognome" : "MAZZONI",
		"nome" : "Nino"
	},
	{
		"id" : "PD0012410",
		"cognome" : "MEDA",
		"nome" : "Luigi"
	},
	{
		"id" : "PD0013780",
		"cognome" : "MEDI",
		"nome" : "Enrico"
	},
	{
		"id" : "PD0013770",
		"cognome" : "MENTASTI",
		"nome" : "Piero"
	},
	{
		"id" : "PD0011880",
		"cognome" : "MERIGHI",
		"nome" : "Mario"
	},
	{
		"id" : "PD0009260",
		"cognome" : "MERLIN",
		"nome" : "Angelina"
	},
	{
		"id" : "PD0028170",
		"cognome" : "MERLIN",
		"nome" : "Umberto"
	},
	{
		"id" : "PD0014220",
		"cognome" : "MEZZADRA",
		"nome" : "Domenico"
	},
	{
		"id" : "PD0011740",
		"cognome" : "MICCOLIS",
		"nome" : "Leonardo"
	},
	{
		"id" : "PD0026450",
		"cognome" : "MICHELI",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0019320",
		"cognome" : "MINELLA MOLINARI",
		"nome" : "Angiola"
	},
	{
		"id" : "PD0011770",
		"cognome" : "MINIO",
		"nome" : "Enrico"
	},
	{
		"id" : "PD0028180",
		"cognome" : "MOLE'",
		"nome" : "Enrico"
	},
	{
		"id" : "PD0028190",
		"cognome" : "MOLINELLI",
		"nome" : "Guido"
	},
	{
		"id" : "PD0028200",
		"cognome" : "MOMIGLIANO",
		"nome" : "Riccardo"
	},
	{
		"id" : "PD0019330",
		"cognome" : "MONTAGNANA",
		"nome" : "Mario"
	},
	{
		"id" : "PD0009380",
		"cognome" : "MONTAGNANA TOGLIATTI",
		"nome" : "Rita"
	},
	{
		"id" : "PD0009390",
		"cognome" : "MONTALBANO",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0028220",
		"cognome" : "MONTEMARTINI",
		"nome" : "Gabriele Luigi"
	},
	{
		"id" : "PD0011420",
		"cognome" : "MONTERISI",
		"nome" : "Vito"
	},
	{
		"id" : "PD0009430",
		"cognome" : "MONTICELLI",
		"nome" : "Reginaldo"
	},
	{
		"id" : "PD0019350",
		"cognome" : "MONTINI",
		"nome" : "Lodovico"
	},
	{
		"id" : "PD0028230",
		"cognome" : "MORANDI",
		"nome" : "Rodolfo"
	},
	{
		"id" : "PD0009440",
		"cognome" : "MORELLI",
		"nome" : "Renato"
	},
	{
		"id" : "PD0013400",
		"cognome" : "MORELLI",
		"nome" : "Luigi"
	},
	{
		"id" : "PD0009450",
		"cognome" : "MORINI",
		"nome" : "Attilio"
	},
	{
		"id" : "PD0004180",
		"cognome" : "MORO",
		"nome" : "Aldo"
	},
	{
		"id" : "PD0009460",
		"cognome" : "MORTATI",
		"nome" : "Costantino"
	},
	{
		"id" : "PD0009480",
		"cognome" : "MOSCATELLI",
		"nome" : "Vincenzo"
	},
	{
		"id" : "PD0011730",
		"cognome" : "MOTOLESE",
		"nome" : "Alfonso"
	},
	{
		"id" : "PD0009490",
		"cognome" : "MURGIA",
		"nome" : "Francesco"
	},
	{
		"id" : "PD0009510",
		"cognome" : "MUSOLINO",
		"nome" : "Eugenio"
	},
	{
		"id" : "PD0026500",
		"cognome" : "MUSOTTO",
		"nome" : "Francesco"
	},
	{
		"id" : "PD0026520",
		"cognome" : "NASI",
		"nome" : "Virgilio"
	},
	{
		"id" : "PD0026530",
		"cognome" : "NATOLI LAMANTEA",
		"nome" : "Aurelio"
	},
	{
		"id" : "PD0013250",
		"cognome" : "NEGARVILLE",
		"nome" : "Celeste Carlo"
	},
	{
		"id" : "PD0019410",
		"cognome" : "NENNI",
		"nome" : "Pietro"
	},
	{
		"id" : "PD0028250",
		"cognome" : "NITTI",
		"nome" : "Francesco Saverio"
	},
	{
		"id" : "PD0009610",
		"cognome" : "NOBILE",
		"nome" : "Umberto"
	},
	{
		"id" : "PD0028260",
		"cognome" : "NOBILI",
		"nome" : "Tito Oro"
	},
	{
		"id" : "PD0009620",
		"cognome" : "NOCE LONGO",
		"nome" : "Teresa"
	},
	{
		"id" : "PD0012280",
		"cognome" : "NOTARIANNI",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0022330",
		"cognome" : "NOVELLA",
		"nome" : "Agostino"
	},
	{
		"id" : "PD0026550",
		"cognome" : "NUMEROSO",
		"nome" : "Raffaele"
	},
	{
		"id" : "PD0026590",
		"cognome" : "ORLANDO",
		"nome" : "Camillo"
	},
	{
		"id" : "PD0028270",
		"cognome" : "ORLANDO",
		"nome" : "Vittorio Emanuele"
	},
	{
		"id" : "PD0009650",
		"cognome" : "PACCIARDI",
		"nome" : "Randolfo"
	},
	{
		"id" : "PD0009680",
		"cognome" : "PAJETTA",
		"nome" : "Giuliano"
	},
	{
		"id" : "PD0004390",
		"cognome" : "PAJETTA",
		"nome" : "Giancarlo"
	},
	{
		"id" : "PD0028280",
		"cognome" : "PALLASTRELLI",
		"nome" : "Giovanni"
	},
	{
		"id" : "PD0009690",
		"cognome" : "PAOLUCCI",
		"nome" : "Silvio"
	},
	{
		"id" : "PD0028290",
		"cognome" : "PARATORE",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0009710",
		"cognome" : "PARIS",
		"nome" : "Danilo"
	},
	{
		"id" : "PD0028300",
		"cognome" : "PARRI",
		"nome" : "Ferruccio"
	},
	{
		"id" : "PD0028310",
		"cognome" : "PASQUALINO VASSALLO",
		"nome" : "Rosario Fu Giuseppe"
	},
	{
		"id" : "PD0011870",
		"cognome" : "PASTORE",
		"nome" : "Giulio"
	},
	{
		"id" : "PD0028320",
		"cognome" : "PASTORE",
		"nome" : "Raffaele"
	},
	{
		"id" : "PD0009730",
		"cognome" : "PAT",
		"nome" : "Bortolo Manlio"
	},
	{
		"id" : "PD0009740",
		"cognome" : "PATRICOLO",
		"nome" : "Gennaro"
	},
	{
		"id" : "PD0009750",
		"cognome" : "PATRISSI",
		"nome" : "Emilio"
	},
	{
		"id" : "PD0013720",
		"cognome" : "PECORARI",
		"nome" : "Fausto"
	},
	{
		"id" : "PD0019540",
		"cognome" : "PELLA",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0028330",
		"cognome" : "PELLEGRINI",
		"nome" : "Giacomo"
	},
	{
		"id" : "PD0026650",
		"cognome" : "PELLIZZARI",
		"nome" : "Achille"
	},
	{
		"id" : "PD0009770",
		"cognome" : "PENNA BUSCEMI",
		"nome" : "Ottavia"
	},
	{
		"id" : "PD0013670",
		"cognome" : "PERA",
		"nome" : "Giovanni Battista"
	},
	{
		"id" : "PD0026660",
		"cognome" : "PERASSI",
		"nome" : "Tomaso"
	},
	{
		"id" : "PD0012070",
		"cognome" : "PERLINGIERI",
		"nome" : "Giovanni"
	},
	{
		"id" : "PD0009780",
		"cognome" : "PERRONE CAPANO",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0028340",
		"cognome" : "PERSICO",
		"nome" : "Giovanni"
	},
	{
		"id" : "PD0004610",
		"cognome" : "PERTINI",
		"nome" : "Alessandro"
	},
	{
		"id" : "PD0011960",
		"cognome" : "PERUGI",
		"nome" : "Giulio"
	},
	{
		"id" : "PD0019570",
		"cognome" : "PESENTI",
		"nome" : "Antonio"
	},
	{
		"id" : "PD0019600",
		"cognome" : "PICCIONI",
		"nome" : "Attilio"
	},
	{
		"id" : "PD0028350",
		"cognome" : "PIEMONTE",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0013080",
		"cognome" : "PIERI",
		"nome" : "Gino"
	},
	{
		"id" : "PD0013070",
		"cognome" : "PIGNATARI",
		"nome" : "Aldo Enzo"
	},
	{
		"id" : "PD0017600",
		"cognome" : "PIGNEDOLI",
		"nome" : "Antonio"
	},
	{
		"id" : "PD0026710",
		"cognome" : "PISTOIA",
		"nome" : "Umberto"
	},
	{
		"id" : "PD0013740",
		"cognome" : "PLATONE",
		"nome" : "Felice"
	},
	{
		"id" : "PD0009900",
		"cognome" : "POLLASTRINI",
		"nome" : "Elettra"
	},
	{
		"id" : "PD0026720",
		"cognome" : "PONTI",
		"nome" : "Giovanni"
	},
	{
		"id" : "PD0028360",
		"cognome" : "PONTICELLI",
		"nome" : "Francesco"
	},
	{
		"id" : "PD0028370",
		"cognome" : "PORZIO",
		"nome" : "Giovanni"
	},
	{
		"id" : "PD0013840",
		"cognome" : "PRATOLONGO",
		"nome" : "Giordano"
	},
	{
		"id" : "PD0012010",
		"cognome" : "PRESSINOTTI",
		"nome" : "Pietro"
	},
	{
		"id" : "PD0004810",
		"cognome" : "PRETI",
		"nome" : "Luigi"
	},
	{
		"id" : "PD0019700",
		"cognome" : "PREZIOSI",
		"nome" : "Costantino"
	},
	{
		"id" : "PD0028380",
		"cognome" : "PRIOLO",
		"nome" : "Antonio"
	},
	{
		"id" : "PD0026730",
		"cognome" : "PROIA",
		"nome" : "Alfredo"
	},
	{
		"id" : "PD0028390",
		"cognome" : "PUCCI",
		"nome" : "Alberto Mario"
	},
	{
		"id" : "PD0026750",
		"cognome" : "PUOTI",
		"nome" : "Renato"
	},
	{
		"id" : "PD0026760",
		"cognome" : "QUARELLO",
		"nome" : "Gioacchino"
	},
	{
		"id" : "PD0026770",
		"cognome" : "QUINTIERI",
		"nome" : "Quinto"
	},
	{
		"id" : "PD0012160",
		"cognome" : "QUINTIERI",
		"nome" : "Adolfo"
	},
	{
		"id" : "PD0009960",
		"cognome" : "RAPELLI",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0022320",
		"cognome" : "RAVAGNAN",
		"nome" : "Riccardo"
	},
	{
		"id" : "PD0028400",
		"cognome" : "REALE",
		"nome" : "Vito"
	},
	{
		"id" : "PD0013570",
		"cognome" : "RECCA",
		"nome" : "Raffaele"
	},
	{
		"id" : "PD0010000",
		"cognome" : "RESCIGNO",
		"nome" : "Matteo"
	},
	{
		"id" : "PD0014360",
		"cognome" : "RESTIVO",
		"nome" : "Francesco"
	},
	{
		"id" : "PD0005030",
		"cognome" : "RICCIO",
		"nome" : "Stefano"
	},
	{
		"id" : "PD0026800",
		"cognome" : "RIVERA",
		"nome" : "Vincenzo"
	},
	{
		"id" : "PD0010050",
		"cognome" : "RODI",
		"nome" : "Cesario"
	},
	{
		"id" : "PD0013120",
		"cognome" : "RODINO'",
		"nome" : "Ugo"
	},
	{
		"id" : "PD0011480",
		"cognome" : "RODINO' DI MIGLIONE",
		"nome" : "Mario"
	},
	{
		"id" : "PD0010060",
		"cognome" : "ROGNONI",
		"nome" : "Arturo"
	},
	{
		"id" : "PD0028420",
		"cognome" : "ROMANO",
		"nome" : "Antonio"
	},
	{
		"id" : "PD0026830",
		"cognome" : "ROMITA",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0026840",
		"cognome" : "ROSELLI",
		"nome" : "Enrico"
	},
	{
		"id" : "PD0010100",
		"cognome" : "ROSSI",
		"nome" : "Paolo"
	},
	{
		"id" : "PD0010090",
		"cognome" : "ROSSI",
		"nome" : "Maria Maddalena"
	},
	{
		"id" : "PD0028440",
		"cognome" : "ROVEDA",
		"nome" : "Giovanni"
	},
	{
		"id" : "PD0028450",
		"cognome" : "RUBILLI",
		"nome" : "Alfonso"
	},
	{
		"id" : "PD0019820",
		"cognome" : "RUGGERI",
		"nome" : "Luigi"
	},
	{
		"id" : "PD0010130",
		"cognome" : "RUGGIERO",
		"nome" : "Carlo"
	},
	{
		"id" : "PD0028460",
		"cognome" : "RUINI",
		"nome" : "Meuccio"
	},
	{
		"id" : "PD0005150",
		"cognome" : "RUMOR",
		"nome" : "Mariano"
	},
	{
		"id" : "PD0012060",
		"cognome" : "RUSSO PEREZ",
		"nome" : "Guido"
	},
	{
		"id" : "PD0010170",
		"cognome" : "SACCENTI",
		"nome" : "Dino"
	},
	{
		"id" : "PD0010190",
		"cognome" : "SAGGIN",
		"nome" : "Mario"
	},
	{
		"id" : "PD0010200",
		"cognome" : "SALERNO",
		"nome" : "Nicola"
	},
	{
		"id" : "PD0005220",
		"cognome" : "SALIZZONI",
		"nome" : "Angelo"
	},
	{
		"id" : "PD0013600",
		"cognome" : "SALVATORE",
		"nome" : "Attilio"
	},
	{
		"id" : "PD0010220",
		"cognome" : "SAMPIETRO",
		"nome" : "Umberto"
	},
	{
		"id" : "PD0026890",
		"cognome" : "SANSONE",
		"nome" : "Luigi Renato"
	},
	{
		"id" : "PD0026900",
		"cognome" : "SANTI",
		"nome" : "Ettore"
	},
	{
		"id" : "PD0028470",
		"cognome" : "SAPIENZA",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0019910",
		"cognome" : "SARAGAT",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0010240",
		"cognome" : "SARDIELLO",
		"nome" : "Gaetano"
	},
	{
		"id" : "PD0060694",
		"cognome" : "SCALFARO",
		"nome" : "Oscar Luigi"
	},
	{
		"id" : "PD0019980",
		"cognome" : "SCARPA",
		"nome" : "Sergio"
	},
	{
		"id" : "PD0019990",
		"cognome" : "SCELBA",
		"nome" : "Mario"
	},
	{
		"id" : "PD0020000",
		"cognome" : "SCHIAVETTI",
		"nome" : "Fernando"
	},
	{
		"id" : "PD0013040",
		"cognome" : "SCHIRATTI",
		"nome" : "Guglielmo"
	},
	{
		"id" : "PD0011760",
		"cognome" : "SCOCA",
		"nome" : "Salvatore"
	},
	{
		"id" : "PD0028480",
		"cognome" : "SCOCCIMARRO",
		"nome" : "Mauro"
	},
	{
		"id" : "PD0011860",
		"cognome" : "SCOTTI",
		"nome" : "Alessandro"
	},
	{
		"id" : "PD0020020",
		"cognome" : "SCOTTI",
		"nome" : "Francesco"
	},
	{
		"id" : "PD0026930",
		"cognome" : "SEGNI",
		"nome" : "Antonio"
	},
	{
		"id" : "PD0012810",
		"cognome" : "SELVAGGI",
		"nome" : "Vincenzo"
	},
	{
		"id" : "PD0010380",
		"cognome" : "SERENI",
		"nome" : "Emilio"
	},
	{
		"id" : "PD0028500",
		"cognome" : "SFORZA",
		"nome" : "Carlo"
	},
	{
		"id" : "PD0013000",
		"cognome" : "SICIGNANO",
		"nome" : "Ludovico"
	},
	{
		"id" : "PD0028510",
		"cognome" : "SILES",
		"nome" : "Nicola"
	},
	{
		"id" : "PD0010410",
		"cognome" : "SILIPO",
		"nome" : "Luigi"
	},
	{
		"id" : "PD0010420",
		"cognome" : "SILONE",
		"nome" : "Ignazio"
	},
	{
		"id" : "PD0012330",
		"cognome" : "SIMONINI",
		"nome" : "Alberto"
	},
	{
		"id" : "PD0028520",
		"cognome" : "SPALLICCI",
		"nome" : "Aldo"
	},
	{
		"id" : "PD0028530",
		"cognome" : "SPANO",
		"nome" : "Velio"
	},
	{
		"id" : "PD0020060",
		"cognome" : "SPATARO",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0028540",
		"cognome" : "STAMPACCHIA",
		"nome" : "Vito Mario"
	},
	{
		"id" : "PD0026990",
		"cognome" : "STELLA",
		"nome" : "Albino Ottavio"
	},
	{
		"id" : "PD0005640",
		"cognome" : "STORCHI",
		"nome" : "Ferdinando"
	},
	{
		"id" : "PD0005660",
		"cognome" : "SULLO",
		"nome" : "Fiorentino"
	},
	{
		"id" : "PD0017160",
		"cognome" : "TADDIA",
		"nome" : "Gherardo"
	},
	{
		"id" : "PD0012540",
		"cognome" : "TAMBRONI ARMAROLI",
		"nome" : "Fernando"
	},
	{
		"id" : "PD0027000",
		"cognome" : "TARGETTI",
		"nome" : "Ferdinando"
	},
	{
		"id" : "PD0200929",
		"cognome" : "TAVIANI",
		"nome" : "Emilio Paolo"
	},
	{
		"id" : "PD0012510",
		"cognome" : "TEGA",
		"nome" : "Renato"
	},
	{
		"id" : "PD0028550",
		"cognome" : "TERRACINI",
		"nome" : "Umberto"
	},
	{
		"id" : "PD0013480",
		"cognome" : "TERRANOVA",
		"nome" : "Corrado"
	},
	{
		"id" : "PD0028560",
		"cognome" : "TESSITORI",
		"nome" : "Tiziano"
	},
	{
		"id" : "PD0012480",
		"cognome" : "TIERI",
		"nome" : "Vincenzo"
	},
	{
		"id" : "PD0010600",
		"cognome" : "TITOMANLIO",
		"nome" : "Vittoria"
	},
	{
		"id" : "PD0014140",
		"cognome" : "TOGLIATTI",
		"nome" : "Palmiro"
	},
	{
		"id" : "PD0020170",
		"cognome" : "TOGNI",
		"nome" : "Giuseppe"
	},
	{
		"id" : "PD0027030",
		"cognome" : "TOMBA",
		"nome" : "Tullio"
	},
	{
		"id" : "PD0028570",
		"cognome" : "TONELLO",
		"nome" : "Tommaso"
	},
	{
		"id" : "PD0013520",
		"cognome" : "TONETTI",
		"nome" : "Giovanni"
	},
	{
		"id" : "PD0010630",
		"cognome" : "TOSATO",
		"nome" : "Egidio"
	},
	{
		"id" : "PD0013260",
		"cognome" : "TOSI",
		"nome" : "Enrico"
	},
	{
		"id" : "PD0005860",
		"cognome" : "TOZZI CONDIVI",
		"nome" : "Renato"
	},
	{
		"id" : "PD0010650",
		"cognome" : "TREMELLONI",
		"nome" : "Roberto"
	},
	{
		"id" : "PD0012110",
		"cognome" : "TREVES",
		"nome" : "Paolo"
	},
	{
		"id" : "PD0010920",
		"cognome" : "TRIMARCHI",
		"nome" : "Michelangelo"
	},
	{
		"id" : "PD0028580",
		"cognome" : "TRIPEPI",
		"nome" : "Domenico"
	},
	{
		"id" : "PD0027040",
		"cognome" : "TRULLI",
		"nome" : "Martino"
	},
	{
		"id" : "PD0010690",
		"cognome" : "TUMMINELLI",
		"nome" : "Michele Maria"
	},
	{
		"id" : "PD0028590",
		"cognome" : "TUPINI",
		"nome" : "Umberto"
	},
	{
		"id" : "PD0028600",
		"cognome" : "TURCO",
		"nome" : "Alessandro"
	},
	{
		"id" : "PD0028610",
		"cognome" : "UBERTI",
		"nome" : "Giovanni"
	},
	{
		"id" : "PD0013680",
		"cognome" : "VALENTI",
		"nome" : "Michele"
	},
	{
		"id" : "PD0200954",
		"cognome" : "VALIANI",
		"nome" : "Leo"
	},
	{
		"id" : "PD0011750",
		"cognome" : "VALLONE",
		"nome" : "Luigi"
	},
	{
		"id" : "PD0028630",
		"cognome" : "VALMARANA",
		"nome" : "Giustino"
	},
	{
		"id" : "PD0028640",
		"cognome" : "VANONI",
		"nome" : "Ezio"
	},
	{
		"id" : "PD0011470",
		"cognome" : "VARVARO",
		"nome" : "Antonino"
	},
	{
		"id" : "PD0011950",
		"cognome" : "VENDITTI",
		"nome" : "Milziade"
	},
	{
		"id" : "PD0027060",
		"cognome" : "VERNOCCHI",
		"nome" : "Olindo"
	},
	{
		"id" : "PD0028650",
		"cognome" : "VERONI",
		"nome" : "Dante"
	},
	{
		"id" : "PD0014330",
		"cognome" : "VIALE",
		"nome" : "Ambrogio"
	},
	{
		"id" : "PD0013910",
		"cognome" : "VICENTINI",
		"nome" : "Rodolfo"
	},
	{
		"id" : "PD0027070",
		"cognome" : "VIGNA",
		"nome" : "Oberdan"
	},
	{
		"id" : "PD0020330",
		"cognome" : "VIGO",
		"nome" : "Gaetano"
	},
	{
		"id" : "PD0012420",
		"cognome" : "VIGORELLI",
		"nome" : "Ezio"
	},
	{
		"id" : "PD0027080",
		"cognome" : "VILLABRUNA",
		"nome" : "Bruno"
	},
	{
		"id" : "PD0012530",
		"cognome" : "VILLANI",
		"nome" : "Ezio"
	},
	{
		"id" : "PD0011910",
		"cognome" : "VINCIGUERRA",
		"nome" : "Ireneo"
	},
	{
		"id" : "PD0010810",
		"cognome" : "VISCHIONI",
		"nome" : "Felice"
	},
	{
		"id" : "PD0017240",
		"cognome" : "VOLPE",
		"nome" : "Calogero"
	},
	{
		"id" : "PD0006210",
		"cognome" : "ZACCAGNINI",
		"nome" : "Benigno"
	},
	{
		"id" : "PD0006230",
		"cognome" : "ZAGARI",
		"nome" : "Mario"
	},
	{
		"id" : "PD0028680",
		"cognome" : "ZANARDI",
		"nome" : "Francesco"
	},
	{
		"id" : "PD0011640",
		"cognome" : "ZAPPELLI",
		"nome" : "Luigi"
	},
	{
		"id" : "PD0010890",
		"cognome" : "ZERBI",
		"nome" : "Tommaso"
	},
	{
		"id" : "PD0028690",
		"cognome" : "ZOTTA",
		"nome" : "Mario"
	},
	{
		"id" : "PD0027120",
		"cognome" : "ZUCCARINI",
		"nome" : "Oliviero"
	}
]
